module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-civil-ceremony-6bbf9b5427eea941c751dc5fe8b2293a.png";